import { Card, Table, Badge, ProgressBar, Alert } from 'react-bootstrap'
import { useQuery } from 'react-query'
import api from '../../services/api'
import { formatCurrency } from '../../utils/formatters'

const BudgetExecution = ({ budget }) => {
  // Obtener ejecución del presupuesto
  const { data: ejecuciones, isLoading } = useQuery(
    ['budget-execution', budget.id],
    async () => {
      const response = await api.get(`/financial/ejecuciones-presupuesto/?presupuesto_id=${budget.id}`)
      return response.data.results || response.data || []
    },
    { enabled: !!budget.id }
  )

  if (isLoading) {
    return <div className="text-center py-5">Cargando...</div>
  }

  return (
    <div>
      <h5 className="mb-3">Ejecución del Presupuesto</h5>
      
      {ejecuciones && ejecuciones.length > 0 ? (
        <Card>
          <Card.Body>
            <Table responsive>
              <thead>
                <tr>
                  <th>Periodo</th>
                  <th>Presupuestado</th>
                  <th>Ejecutado</th>
                  <th>Comprometido</th>
                  <th>Disponible</th>
                  <th>% Ejecución</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                {ejecuciones.map((ejecucion) => {
                  const disponible = ejecucion.monto_presupuestado - ejecucion.monto_ejecutado - ejecucion.monto_comprometido
                  const porcentaje = ejecucion.monto_presupuestado > 0
                    ? (ejecucion.monto_ejecutado / ejecucion.monto_presupuestado) * 100
                    : 0
                  const variant = porcentaje > 100 ? 'danger' : porcentaje > 80 ? 'warning' : 'success'
                  
                  return (
                    <tr key={ejecucion.id}>
                      <td>
                        {ejecucion.mes ? `${ejecucion.mes}/${ejecucion.año}` : ejecucion.periodo || 'N/A'}
                      </td>
                      <td>
                        {formatCurrency(ejecucion.monto_presupuestado || 0)}
                      </td>
                      <td>
                        {formatCurrency(ejecucion.monto_ejecutado || 0)}
                      </td>
                      <td>
                        {formatCurrency(ejecucion.monto_comprometido || 0)}
                      </td>
                      <td>
                        <span className={disponible < 0 ? 'text-danger' : 'text-success'}>
                          {formatCurrency(disponible)}
                        </span>
                      </td>
                      <td>
                        <ProgressBar
                          variant={variant}
                          now={Math.min(porcentaje, 100)}
                          label={`${porcentaje.toFixed(1)}%`}
                          style={{ width: '100px' }}
                        />
                      </td>
                      <td>
                        <Badge bg={ejecucion.estado === 'alerta' ? 'warning' : 'success'}>
                          {ejecucion.estado || 'Normal'}
                        </Badge>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      ) : (
        <Alert variant="info">
          No hay datos de ejecución disponibles. La ejecución se calcula automáticamente.
        </Alert>
      )}
    </div>
  )
}

export default BudgetExecution

